import React from "react";
import styled, { css } from "styled-components";
import Link from "components/Link";
import Box from "components/global/Box";
import { UnorderedList } from "components/Lists";

const TabLink = styled(Link)`
  display: block;
  ${(props) =>
    props.$active
      ? css`
          color: ${(props) => props.theme.colors.blue[600]};
          border-bottom: 4px solid;
        `
      : css`
          color: ${(props) => props.theme.colors.neutral[1000]};
          border-bottom: none;
        `}

  && {
    margin-bottom: -1px;
  }

  &:hover {
    text-decoration: none;
  }
`;

const Tabs = (props) => (
  <UnorderedList
    unstyled
    display="flex"
    as="ul"
    p={0}
    ml={0}
    borderBottom="1px solid"
    borderColor="neutral.200"
    role="tablist"
    {...props}
  />
);

Tabs.Item = ({ to, children, active }) => (
  <Box as="li" role="presentation">
    <TabLink
      $active={active}
      to={to}
      px={500}
      pb={200}
      role="tab"
      aria-selected={active}
    >
      {children}
    </TabLink>
  </Box>
);

export default Tabs;
